import { checkIncludeAppName } from '@/hooks/useAuthorityLevel';

// Tema lúdico, controlado pelo tenant REACT_APP_NAME (build-time, global, por deploy).
// Tenants nesta lista ativam o layout lúdico em TODA a interface (home + gate da
// trilha); qualquer outro tenant mantém o layout original. Fonte única de
// verdade para gatear ajustes de UI.
const PLAYFUL_APP_NAMES = ['floriano-educa-7', 'canaleducacao', 'kubi'];

export const isPlayfulTheme = () => checkIncludeAppName({ only: PLAYFUL_APP_NAMES });
